let view = null;

export default {
	namespace: 'template-insights',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: InsightsView } = await import(
			/* webpackChunkName: "insights-view" */ '../../templates/InsightsView'
		);
		view = new InsightsView(next.container);
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
